export default __webpack_public_path__ + "static/media/partner-1.c9ea6340.png";